var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_5590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 0H4.16672C1.86586 0 0 1.86583 0 4.16667V15.8333C0 18.1342 1.86586 20 4.16672 20H15.8335C18.1352 20 20.0003 18.1342 20.0003 15.8333V4.16667C20.0003 1.86583 18.1352 0 15.8335 0ZM6.66675 15.8333H4.16672V6.66667H6.66675V15.8333ZM5.41674 5.61C4.61173 5.61 3.95838 4.95167 3.95838 4.14C3.95838 3.32833 4.61173 2.67 5.41674 2.67C6.22175 2.67 6.87509 3.32833 6.87509 4.14C6.87509 4.95167 6.22258 5.61 5.41674 5.61ZM16.6669 15.8333H14.1669V11.1633C14.1669 8.35667 10.8335 8.56917 10.8335 11.1633V15.8333H8.33344V6.66667H10.8335V8.1375C11.9968 5.9825 16.6669 5.82333 16.6669 10.2008V15.8333Z",
    fill: "#2867B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_5590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.0003,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/LinkedinLogo.2735d8a7a511c59a7566d234cea7839f.svg";
export { ForwardRef as ReactComponent };